import { useLogger } from "@amzn/xb-hooks";
import { useSuspenseQuery } from "@apollo/client";
import { FC } from "react";
import { withErrorBoundary } from "react-error-boundary";
import { LiveInterceptorFactoryInfo } from "../../live-component";
import { PrefetchQueryInterface } from "./types";

export const suspendedPrefetchQueryInterceptorFactory = <TProps extends PrefetchQueryInterface>(
  { fallback }: LiveInterceptorFactoryInfo,
  Response: FC<any>
) => {
  const ResponseWithPrefetchQuery: FC<TProps> = ({ suspendedPrefetchQueryCallback, ...otherProps }) => {
    const { query, variables, skip } = suspendedPrefetchQueryCallback?.(otherProps) ?? {};
    const { log } = useLogger();
    const child = <Response {...otherProps} />;
    const SuspendedPrefetch = withErrorBoundary(
      () => {
        // hook is within a higher-order-component error boundary
        // eslint-disable-next-line
        useSuspenseQuery(query!, {
          variables,
          skip,
        });
        return child;
      },
      {
        fallback: child,
        onError: (error: Error) => {
          log.error("Error encountered during prefetch query", error);
        },
      }
    );
    return query ? <SuspendedPrefetch /> : child;
  };
  return ResponseWithPrefetchQuery;
};
